import { useQuery } from "@tanstack/react-query";
import { UnitConfigDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_QUESTION_UNITS } from "../domain";

import { Error } from "@helpers";
import { questionsUnitApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const fetchQuestionUnits = async (): Promise<UnitConfigDto[] | undefined> => {
  try {
    const response =
      await questionsUnitApi.questionUnitsControllerGetQuestionUnits();

    const data = response.data;

    if (response.status === 200 && data) {
      return data;
    }
  } catch (error) {
    Error(error);
  }
};

export const useGetQuestionUnits = (
  user: UserProfileDto | null,
): {
  units?: UnitConfigDto[];
  unitsEnabled: boolean;
  isLoadingQuestionUnits: boolean;
  isFetchingQuestionUnits: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isLoading, isFetching, data } = useQuery({
    queryKey: [DOMAIN_QUESTION_UNITS],
    queryFn: fetchQuestionUnits,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    units: data,
    unitsEnabled: enabled,
    isLoadingQuestionUnits: isLoading,
    isFetchingQuestionUnits: isFetching,
  };
};
